import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=498933be&scoped=true&"
import script from "./footBar.vue?vue&type=script&lang=js&"
export * from "./footBar.vue?vue&type=script&lang=js&"
import style0 from "./footBar.vue?vue&type=style&index=0&id=498933be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498933be",
  null
  
)

export default component.exports